module.exports = __webpack_public_path__ + "static/media/karthika.0ddae9c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/karthika.jpg
// module id = 192
// module chunks = 0